// components/CheckboxDropdown.jsx
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import './CheckboxDropdown.css';

const CheckboxDropdown = ({
  label,
  options,
  selectedValues,
  onToggle,
  onSelectAll,
  onClearAll,
  placeholder = "Оберіть опції",
  selectAllLabel = "Вибрати всі",
  clearLabel = "Скинути вибір",
  showTags = true,
  className = ""
}) => {
  
  const allSelected = selectedValues.length === options.length;
  const hasSelections = selectedValues.length > 0;

  // Форматируем текст для отображения выбранных значений
  const getSelectedText = () => {
    if (selectedValues.length === 0) return placeholder;
    if (selectedValues.length === 1) {
      const selectedOption = options.find(opt => opt.value === selectedValues[0]);
      return selectedOption?.label || selectedValues[0];
    }
    if (allSelected) return "Всі опції";
    return `Обрано ${selectedValues.length}`;
  };

  return (
    <div className={`checkbox-dropdown ${className}`}>
      {label && (
        <label className="form-label fw-semibold mb-2">
          {label}
        </label>
      )}
      
      <Dropdown className="checkbox-dropdown-selector">
        <Dropdown.Toggle variant="outline-secondary" className="checkbox-dropdown-btn">
          {getSelectedText()}
        </Dropdown.Toggle>
        <Dropdown.Menu className="checkbox-dropdown-menu">
          {/* Кнопка вибрати все */}
          <Dropdown.Item 
            as="button"
            className={`filter-item ${allSelected ? 'active' : ''}`}
            onClick={onSelectAll}
          >
            <div className="filter-checkbox">
              {allSelected && (
                <span className="filter-checkmark">✓</span>
              )}
            </div>
            {selectAllLabel}
          </Dropdown.Item>
          
          <Dropdown.Divider />
          
          {/* Список опций */}
          {options.map((option, index) => (
            <Dropdown.Item 
              key={option.value || index}
              as="button"
              className={`filter-item ${selectedValues.includes(option.value) ? 'active' : ''}`}
              onClick={() => onToggle(option.value)}
            >
              <div className="filter-checkbox">
                {selectedValues.includes(option.value) && (
                  <span className="filter-checkmark">✓</span>
                )}
              </div>
              {option.label}
            </Dropdown.Item>
          ))}
          
          <Dropdown.Divider />
          
          {/* Кнопка скинути */}
          <Dropdown.Item 
            as="button"
            className="filter-clear"
            onClick={onClearAll}
          >
            {clearLabel}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      
      {/* Теги выбранных значений */}
      {showTags && hasSelections && (
        <div className="selected-tags mt-2">
          {selectedValues.map(value => {
            const option = options.find(opt => opt.value === value);
            const displayLabel = option?.label || value;
            return (
              <span 
                key={value} 
                className="selected-tag"
                onClick={() => onToggle(value)}
              >
                {displayLabel}
                <span className="tag-remove">×</span>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CheckboxDropdown;